import React, { useState, useEffect } from 'react';
import './Schedule.css';
import { Calendar, momentLocalizer, Views } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { fetchAppointments } from '../../../API/functions';
import socket from '../../../API/socket';
import { useFileContext } from '../../../Context/FileContext';

const localizer = momentLocalizer(moment);

const Schedule = () => {
  const [events, setEvents] = useState([]);
  const { setShowModal, setFormType } = useFileContext(); // Get modal state and setter


  useEffect(() => {
    const fetchAndUpdateAppointments = async () => {
      try {
        await fetchAppointments(setEvents);
      } catch (error) {
        console.error('Error fetching appointments:', error);
      }
    };

    fetchAndUpdateAppointments();

    // Listen for updates from WebSocket
    socket.on('appointmentChanged', async (updatedAppointment) => {
      try {
        await fetchAndUpdateAppointments();
      } catch (error) {
        console.error('Error updating appointments:', error);
      }
    });

    // Clean up WebSocket listeners on component unmount
    return () => {
      socket.off('appointmentChanged');
    };
  }, [setEvents]);

  const formatDate = () => {
    const today = new Date();
    const options = { weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric' };
    return today.toLocaleDateString('en-US', options);
  };

  const handleEditClick = () => {
    setFormType('edit')
    setShowModal(true); // Show modal when edit button is clicked
  };

  return (
    <div className="schedule">
      <div className="header">
        <h2>{`The Day: ${formatDate().split(',')[0]}, The Date: ${formatDate().split(',')[1]}`}</h2>
        <div className="edit-button" onClick={handleEditClick}></div>
      </div>
      <div className="schedule-wrapper">
        <div className="calendar-container">
          <Calendar
            localizer={localizer}
            events={events}
            startAccessor="start"
            endAccessor="end"
            style={{ height: '80vh', width: '100%' }}
            views={['month', 'week', 'day']}
            defaultView={Views.WEEK}
            onSelectEvent={(event) => alert(event.title)}
            eventPropGetter={(event) => ({
              className: event.className || ''
            })}
            min={moment('8:00am', 'h:mma').toDate()}
            max={moment('9:00pm', 'h:mma').toDate()}
          />
        </div>
      </div>
    </div>
  );
};

export default Schedule;